import { Component } from 'react';
import Raven from 'raven-js';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
    Raven.captureException(error, {
      extra: {
        errorInfo
      },
      level: 'critical'
    });
  }
  render() {
    const {
      error
    } = this.state;
    if (error) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        children: /*#__PURE__*/_jsx("p", {
          children: error.toString()
        })
      });
    }
    return this.props.children;
  }
}
export default ErrorBoundary;